// extracted by mini-css-extract-plugin
module.exports = {"commentItem":"CommentItem_commentItem__1eMVC","showReplay":"CommentItem_showReplay__dIX1T"};